var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArchipelagosLabsCostIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 70 70",
    style: {
      enableBackground: "new 0 0 70 70"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:1.5;stroke-linejoin:round;}\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000104669660982462266050000015234803149078376621_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Copy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.2,31.2h-7.6L58,10.7l11.5,20.5h-7.7v32c0,0.7-0.6,1.3-1.3,1.3h-5.1c-0.7,0-1.3-0.6-1.3-1.3V31.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.7,38.8h5.1c0.7,0,1.3,0.6,1.3,1.3v23c0,0.7-0.6,1.3-1.3,1.3h-5.1c-0.7,0-1.3-0.6-1.3-1.3v-23 C41.4,39.4,42,38.8,42.7,38.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.9,51.6H35c0.7,0,1.3,0.6,1.3,1.3v10.2c0,0.7-0.6,1.3-1.3,1.3h-5.1c-0.7,0-1.3-0.6-1.3-1.3V52.9 C28.6,52.2,29.2,51.6,29.9,51.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 14.5,
    cy: 10.7,
    r: 5.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 14.5,
    y1: 46.5,
    x2: 14.5,
    y2: 64.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.2,27.3L3.1,46.5h5.1v16.6c0,0.7,0.6,1.3,1.3,1.3h10.2c0.7,0,1.3-0.6,1.3-1.3V46.5H26l-4.4-19.9 c-0.3-1.4,0.6-2.8,2-3.1c0.2,0,0.4-0.1,0.6-0.1h16c1.4,0,2.6-1.1,2.6-2.5c0,0,0,0,0,0l0,0c0-1.4-1.1-2.6-2.6-2.6c0,0,0,0,0,0H19.7 l-5.1,6.4l-5.1-6.4l0,0c-2.3,0-4.3,1.5-4.9,3.7L0.7,35.4C-0.1,38,1.4,40.8,4,41.7l0.3,0.1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchipelagosLabsCostIcon);
export default __webpack_public_path__ + "static/media/Archipelagos_Labs-CostIcon.e62d7521d9b8ec08bbdd598977ddcd9c.svg";
export { ForwardRef as ReactComponent };